global.$ = global.jQuery = require('jquery');
import 'jquery-migrate';
import 'jquery-ui/dist/jquery-ui';